export default {
  THP: /^E[A-Z]{1}[0-9]{9}TH$/,
  ECP: /^OF[0-9]{9}TH$/,
  TP2: /^R[A-Z]{1}[0-9]{9}TH$/,
  EMST: /^E[A-Z]{1}[0-9]{9}TH$/,
  EMSW: /^E[A-Z]{1}[0-9]{9}TH$/,
  EMSX: /^E[A-Z]{1}[0-9]{9}TH$/,
  EMSXP: /^E[A-Z]{1}[0-9]{9}TH$/,
};
